<!--
	Clone dari searchMaterial.vue (file lama dibiarkan sebagai history, masih memakai CataloguerForm.vue lama).
	Merender New_CataloguerForm (FORM02, lihat saja); form_code/item_source/mcr_type dari GeneralSetting
	meta route (router/index.js), logika bersama di New_searchPageMixin.js.
-->
<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="card-header pt-3 pb-0"></div>

      <div class="card-body pt-0">
        <div v-if="searchContextError" class="text-muted text-center small py-4">{{ searchContextError }}</div>
        <CataloguerForm
          v-else-if="searchReady"
          ref="cataloguerForm"
          readonly
          :search-context="searchContext"
          :search-columns="searchColumns"
          :list-loading="listLoading"
          :loading-more="smPagination.loadingMore"
          @load-more="loadMore"
        />
        <!-- form config masih dimuat -->
        <CataloguerFormSkeleton v-else />
      </div>
    </div>
  </div>
</template>

<script>
import CataloguerForm from "../materialCatalogRequest/New_CataloguerForm.vue";
import CataloguerFormSkeleton from "./New_CataloguerFormSkeleton.vue";
import advanceSearchService from "@/services/generalLayout/advanceSearchService";
import materialNumberFormatter from "@/helpers/materialNumberFormatter";
import { initialFormData, queryFields } from "./materialSearchFields";
import searchPageMixin from "./New_searchPageMixin";

export default {
  name: "SearchMaterial",
  components: {
    CataloguerForm,
    CataloguerFormSkeleton,
  },
  mixins: [searchPageMixin],
  computed: {
    searchColumns() {
      return [
        { field: "material_number", header: "Material Number", getter: (data) => materialNumberFormatter.formatMaterialNumber(data.material_number) },
        { field: "short_text", header: "Short Text" },
        // Baris dari search = kode string; setelah diklik diganti hasil getMaterialDetail = object -> tampilkan kodenya.
        { field: "material_type", header: "Material Type", getter: (data) => data.material_type?.code ?? data.material_type },
        { field: "material_group", header: "Material Group", getter: (data) => data.material_group?.code ?? data.material_group },
        { field: "uom", header: "UOM" },
        { field: "item_type", header: "Item Type" },
        { field: "updated_by", header: "Updated By" },
      ];
    },
  },
  methods: {
    searchRequest(params) {
      return advanceSearchService.search(params);
    },
    readQuery(query) {
      const formData = { ...initialFormData };
      queryFields.forEach((field) => {
        if (query[field] !== undefined) formData[field] = query[field];
      });
      return formData;
    },
    buildSearchParams(overrides) {
      return this.buildMaterialSearchParams(overrides);
    },
  },
};
</script>
